export default function () {
  // this.doLoad()

  this.checkDomainOperator()
}



// WEBPACK FOOTER //
// ./src/app/patient/loading-page/gadget/resources/mounted.js